<script setup lang="ts">
// eslint-disable-next-line vue/block-tag-newline
import GoogleOAuthIntegration from './GoogleOAuth';
</script>

<template>
  <div>
    <GoogleOAuthIntegration />
  </div>
</template>
